/**
*  料金シミュレーター
*
*  入所 & 入所（認知棟）
*
*  @since 2019.9.3
*  @use jQuery
*/



/**
*  Variables
*
*  自己負担となる利用金額
*/

//入所
const array_entrance = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1680, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 408, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 3760, 2520, 2520, 3340 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1622, 3244, 4866 ],
        two  : [ 0, 0, 0 ]
      },
      single : [ 1532, 3065, 4598 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1704, 3409, 5114 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1613, 3226, 4839 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1775, 3550, 5325 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1682, 3365, 5047 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1837, 3675, 5513 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1745, 3490, 5235 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1899, 3798, 5697 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1807, 3615, 5423 ]
    }
  ]
}

//入所（認知棟）
const array_entranceSub = {
  // 所得段階 : [ 無, 第1段階, 第2段階, 第3段階 ]
  income : [ 1680, 300, 390, 650 ],

  /* 居住費 */
  // 多床室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  multi  : {
    four : [ 408, 0, 370, 370 ],
    two  : [ 0, 0, 0, 0 ]
  },
  // 個室 : [ 無, 第1段階, 第2段階, 第3段階 ]
  single : [ 1730, 490, 490, 1310 ],

  /* 介護度に応じたサービス料 */
  kaigo :
  [
    { // 介護度 1 : [ 1割, 2割, 3割 ]
      multi  : {
        four : [ 1713, 3427, 5141 ],
        two  : [ 0, 0, 0 ]
      },
      single : [ 1624, 3248, 4873 ]
    },
    { // 介護度 2 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1796, 3593, 5389 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1704, 3409, 5114 ]
    },
    { // 介護度 3 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1866, 3733, 5600 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1774, 3548, 5322 ]
    },
    { // 介護度 4 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1929, 3858, 5788 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1836, 3673, 5510 ]
    },
    { // 介護度 5 : [ 1割, 2割, 3割 ]
      multi  : {
          four : [ 1990, 3981, 5972 ],
          two  : [ 0, 0, 0 ]
        },
      single : [ 1899, 3798, 5697 ]
    }
  ]
}



/**
*  function
*  動作
*/

// 入所
$( calcBtn.entrance ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entrance ).serializeArray();
  const selectVal = selectCheck( currentForm.entrance, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entrance.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entrance.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entrance.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entrance.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する
    const result = ( array_entrance.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entrance ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});

// 入所（認知棟）
$( calcBtn.entranceSub ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.entranceSub ).serializeArray();
  const selectVal = selectCheck( currentForm.entranceSub, formData );
  let roomExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 部屋タイプに応じて居住費を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        roomExpense = array_entranceSub.multi.four[ selectVal.syotoku ];
      break;
      // 多床室（2人）
      case 2:
        roomExpense = array_entranceSub.multi.two[ selectVal.syotoku ];
      break;
      // 個室
      case 3:
        roomExpense = array_entranceSub.single[ selectVal.syotoku ];
      break;
      // default
      default:
        return;
      break;
    }

    // 部屋タイプと介護度に応じてサービス料を設定
    switch( parseInt( selectVal.room, 10 ) )
    {
      // 多床室（4人）
      case 1:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].multi.four[ selectVal.futan ];
      break;
      // 多床室（2人）
      case 2:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].multi.two[ selectVal.futan ];
      break;
      // 個室
      case 3:
        serviceExpense = array_entranceSub.kaigo[ selectVal.kaigo ].single[ selectVal.futan ];
      break;
      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する

    const result = ( array_entranceSub.income[ selectVal.syotoku ] + roomExpense + serviceExpense ) * 31;
    $( resultElm.entranceSub ).html( numberWithComma.format( result ) );

  } // end of 計算処理開始

return;

});
